import styled, { css } from 'styled-components';
import { withChevron } from 'app/theme';

export const List = styled.div`
  padding: 12px 0;
  margin-bottom: ${({ theme }) => theme.indent.m};
  border-bottom: ${({ theme }) => theme.color.borderDark} solid 1px;
`;

export const Item = styled.div`
  font-size: 1.8rem;
  line-height: 1.33;
  color: ${({ theme }) => theme.color.textPrimary};
  ${withChevron}

  & + & {
    margin-left: 10px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.color.accent};

      & ~ ${Item} {
        color: ${({ theme }) => theme.color.textSecondary};
      }
    `}

  & > ._with-chevron {
    padding-right: 15px;

    &::after {
      width: 0.55em;
      height: 0.55em;
      top: 0.45em;
      border-width: 0.1em 0.1em 0 0;
      transform: rotate(45deg);
    }
  }

  &:last-child > span {
    padding-right: 0;

    &::after {
      display: none;
    }
  }
`;
